import { ViewportScroller } from '@angular/common'
import { inject, Injectable } from '@angular/core'
import { EventType, NavigationEnd, Router, Scroll } from '@angular/router'
import { filter, map, pairwise } from 'rxjs'

import { filterIfInstanceOf } from 'app/utils/rxjs/filter-if-instance-of.operator'

@Injectable()
export class RouteScrollHandler {
  private readonly router = inject(Router)
  private readonly viewportScroller = inject(ViewportScroller)

  readonly setup = () => {
    this.router.events
      .pipe(
        filterIfInstanceOf(Scroll),
        filter(
          (event): event is Scroll & { routerEvent: NavigationEnd } =>
            event.routerEvent.type === EventType.NavigationEnd,
        ),
        map(
          (event) =>
            [
              event,
              event.routerEvent.urlAfterRedirects
                .replace(/\?.+$/, '') // remove QueryParams
                .replaceAll(/;[^/]+/g, ''), // remove MatrixParams
            ] as const,
        ),
        pairwise(),
      )
      .subscribe(([[, prevPath], [{ position, anchor }, newPath]]) => {
        if (position) {
          // backward navigation
          setTimeout(() => this.viewportScroller.scrollToPosition(position))
        } else if (anchor) {
          // anchor navigation
          setTimeout(() => this.viewportScroller.scrollToAnchor(anchor))
        } else {
          // forward navigation
          if (prevPath !== newPath) {
            // only if path changed
            setTimeout(() => this.viewportScroller.scrollToPosition([0, 0]))
          }
        }
      })
  }
}
